import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AddressState } from "../address.state";

export const selectState = createFeatureSelector<AddressState>("address");

export const getAddress = (id: number) => createSelector(selectState, (state: AddressState) => state?.addresses?.[id] || null);
